export const environment = {
    production: false,
  ACTUATOR_URL: 'https://gca.traces.com.co/api/v1/dev/',
  AUTHPROVIDER_URL : 'https://gca.traces.com.co/api/v1/dev',
  TRACRBACK_URL : 'https://gca.traces.com.co/api/v1/dev',
  CATALOGS_URL: 'https://gca.traces.com.co/api/v1/dev',
  ROAD_MANAGEMENT_URL: 'https://gca.traces.com.co/api/v1/dev',
  ACCIDENT_URL: 'https://gca.traces.com.co/api/v1/dev',
  WEBSOCKET_URL: 'wss://gca.traces.com.co/api/v1/dev/updates',
    ACTIVE_DEVICES: true,
    ACTIVE_INFO_VERSION: false,
    GOOGLE_MAPS_API_KEY: 'AIzaSyB3dtM0sta3lg4NFArfNZWxTqBtnhNjXao',
    TIME_OUT_DIALOG: 2000,
    INITIAL_COORDINATES: {
      latitude: 3.43722,
      longitude: -76.5225
    },
    VERSION_CLIENT: '1.0.0',
    VERSION_SERVER: '2.0.0'
  };